// guard-patrol.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GuardPatrolState } from '../states/guard-patrol.state';

export const selectGuardPatrolState =
  createFeatureSelector<GuardPatrolState>('guardPatrolState');

export const selectUserPatrolData = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.userPatrolData
);

export const selectHasPatrollingAssignment = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.hasPatrollingAssignment
);

export const selectAssignedGeofences = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.assignedGeofences
);

export const selectPatrolSessions = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.patrolSessions
);

export const selectUserPatrolSessions = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.userPatrolData?.sessions
);

export const selectCurrentPatrolSession = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.currentPatrolSession
);

export const selectPatrolViolations = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.patrolViolations
);

export const selectPatrolStatistics = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.statistics
);

export const selectPatrolLoading = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.loading
);

export const selectPatrolError = createSelector(
  selectGuardPatrolState,
  (state: GuardPatrolState) => state.error
);

export const selectTotalAssignedGeofences = createSelector(
  selectAssignedGeofences,
  (geofences) => geofences.length
);

export const selectActivePatrolSession = createSelector(
  selectUserPatrolSessions,
  (sessions) => sessions?.find((s) => s.isActive) || null
);

const safeViolations = (violations: any): any[] =>
  Array.isArray(violations) ? violations : [];

export const selectUnresolvedViolations = createSelector(
  selectPatrolViolations,
  (violations) =>
    safeViolations(violations).filter((v) => v?.isResolved === false)
);

export const selectViolationStats = createSelector(
  selectPatrolViolations,
  (violations) => {
    const safe = safeViolations(violations);
    return {
      total: safe.length,
      resolved: safe.filter((v) => v?.isResolved === true).length,
      unresolved: safe.filter((v) => v?.isResolved === false).length,
    };
  }
);
